<template>
  <div class="awardRecord">
    <div class="awardRecord-header">
      获得商品奖励的用户，平台需要获取您的收货地址，与客服联系：
      <b @click="dialPhone('0752-2162293')">0752-2162293</b>
    </div>
    <van-list
      v-model="isUpLoading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onReachBottom"
    >
      <div
        class="awardRecord-item"
        v-for="(item,index) in awardList"
        :key="index"
      >
        <div class="title">{{item.rankType == 0 ? "邀请好友排名：" : "首单用户排名："}}第{{item.rank}}名</div>
        <div class="content">
          <span class="van-ellipsis">{{item.awardType == 0 ? `优惠券${item.walletMoney}元` : item.awardType == 1 ? `零钱${item.walletMoney}元` : item.productName}}</span>
          <span style="white-space: pre;" v-if="item.awardType == 2"> * {{item.amount}}</span>
        </div>
        <div class="timer">{{item.startTime}}至{{item.endTime}}</div>
      </div>
      <div
        class="notAwardRecord"
        v-if="!awardList.length&&!isUpLoading&&!error"
      >
        <img
          src="../../assets/img/kongshuju.png"
          alt=""
        >
        <p>暂无获奖记录</p>
        <van-button
          class="invite-btn"
          text="立即邀请"
          block
          @click="goToBack"
        />
      </div>
    </van-list>
  </div>
</template>

<script>
import { awardRecordList } from "@/api/join";
export default {
  data() {
    return {
      awardList: [],
      isUpLoading: true,
      finished: false,
      pageIndex: 1,
      error: false
    }
  },
  methods: {
    goToBack() {
      if (this.$store.getters.ambientType == 0) {
        wx.miniProgram.navigateBack();
      } else {
        this.$router.go(-1);
      }
    },
    onReachBottom() {
      this.getAwardRecordList();
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    getAwardRecordList() {
      awardRecordList({
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        type: this.active == 0 ? "1" : "0", //286 0是邀请，1 首单，后台默认接收参数0
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.list;
            if (list.length < 10) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            // 处理数据
            if (this.pageIndex === 1) {
              this.awardList = list;
            } else {
              this.awardList = this.awardList.concat(list);
            }
            this.pageIndex++;
          } else {
            this.error = true;
          }
          this.isUpLoading = false;
        })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    }
  },
  mounted() {
    this.getAwardRecordList();
  }
}
</script>

<style lang="scss" scoped>
.awardRecord {
  padding-bottom: 20px;
  .awardRecord-header {
    width: 338px;
    line-height: 19px;
    margin: 10px auto 0;
    font-size: 13px;
    color: #333333;
    b {
      font-weight: 400;
      color: #2689fb;
    }
  }
  .awardRecord-item {
    margin: 10px 10px 0;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 5px;
    &:first-child {
      margin-top: 15px;
    }
    .title {
      height: 40px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      font-size: 13px;
      color: #333333;
    }
    .content {
      width: 324px;
      height: 100px;
      line-height: 100px;
      margin: 0 auto;
      font-size: 30px;
      color: #333333;
      text-align: center;
      display: flex;
      justify-content: center;
    }
    .timer {
      height: 40px;
      line-height: 40px;
      padding: 0 17px;
      font-size: 15px;
      color: #999999;
    }
  }
  .notAwardRecord {
    margin-top: 156px;
    text-align: center;
    img {
      width: 88px;
      height: 83px;
      margin: 0 auto;
      display: block;
    }
    p {
      margin-top: 21px;
      font-size: 13px;
      color: #999999;
    }
    .invite-btn {
      width: 250px;
      height: 44px;
      margin: 54px auto 0;
      font-size: 16px;
      color: #ffffff;
      background-color: #ff1310;
      border-radius: 22px;
    }
  }
}
</style>